module.exports = __webpack_public_path__ + "static/media/benefits-slp.52788378.jpg";